import { graphql } from '@/lib/graphql';

export const OrganizationPhoneNumbersSubscription = graphql(`
  subscription OrganizationPhoneNumbers($organizationId: Uuid!) {
    phoneNumbers(where: { organizationId: { _eq: $organizationId } }, orderBy: { phoneNumber: ASC }) {
      id
      phoneNumber
      friendlyName
      status
      flowId
      flow {
        id
        name
      }
    }
  }
`);

export const OrganizationFlowsSubscription = graphql(`
  subscription OrganizationFlowOptions($organizationId: Uuid!) {
    flows(where: { organizationId: { _eq: $organizationId }, deletedAt: { _isNull: true } }, orderBy: { name: ASC }) {
      id
      name
    }
  }
`);

export const UpdatePhoneNumberFriendlyNameMutation = graphql(`
  mutation UpdatePhoneNumberFriendlyName($id: Uuid!, $friendlyName: String) {
    updatePhoneNumbersByPk(pkColumns: { id: $id }, _set: { friendlyName: $friendlyName }) {
      id
      friendlyName
    }
  }
`);
